// Business hours configuration and helpers (Ecuador timezone GMT-5)

export const businessHours = {
  matriz: {
    0: null,
    1: { open: '08:30', close: '19:00' },
    2: { open: '08:30', close: '19:00' },
    3: { open: '08:30', close: '19:00' },
    4: { open: '08:30', close: '19:00' },
    5: { open: '08:30', close: '19:00' },
    6: { open: '08:30', close: '19:00' }
  },
  sucursal: {
    0: { open: '09:00', close: '13:00' },
    1: { open: '10:00', close: '19:00' },
    2: { open: '10:00', close: '19:00' },
    3: { open: '10:00', close: '19:00' },
    4: { open: '10:00', close: '19:00' },
    5: { open: '10:00', close: '19:00' },
    6: { open: '09:00', close: '18:00' }
  }
};

export const getEcuadorTime = () => {
  const now = new Date();
  const ecuadorOffset = -5 * 60;
  const localOffset = now.getTimezoneOffset();
  const diff = ecuadorOffset - (-localOffset);
  return new Date(now.getTime() + diff * 60 * 1000);
};

export const timeToMinutes = (timeStr) => {
  const [hours, mins] = timeStr.split(':').map(Number);
  return hours * 60 + mins;
};

export const minutesToTime = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

// Get next valid delivery date and time
export const getNextOpenDateTime = () => {
  const now = getEcuadorTime();
  const currentDayOfWeek = now.getDay();
  const currentTimeMinutes = now.getHours() * 60 + now.getMinutes();
  
  const todayHours = businessHours.matriz[currentDayOfWeek];
  
  if (todayHours) {
    const openMinutes = timeToMinutes(todayHours.open);
    const closeMinutes = timeToMinutes(todayHours.close);
    
    let earliestMinutes = currentTimeMinutes + 120;
    earliestMinutes = Math.ceil(earliestMinutes / 30) * 30;
    
    if (currentTimeMinutes < openMinutes) {
      earliestMinutes = Math.max(earliestMinutes, openMinutes + 120);
    }
    
    if (earliestMinutes >= openMinutes && earliestMinutes < closeMinutes) {
      const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
      return { date: todayStr, time: minutesToTime(earliestMinutes) };
    }
  }
  
  for (let i = 1; i <= 7; i++) {
    const checkDate = new Date(now);
    checkDate.setDate(now.getDate() + i);
    const dayOfWeek = checkDate.getDay();
    const hours = businessHours.matriz[dayOfWeek];
    
    if (hours) {
      const openMinutes = timeToMinutes(hours.open);
      const deliveryMinutes = openMinutes + 120;
      const dateStr = `${checkDate.getFullYear()}-${String(checkDate.getMonth() + 1).padStart(2, '0')}-${String(checkDate.getDate()).padStart(2, '0')}`;
      return { date: dateStr, time: minutesToTime(deliveryMinutes) };
    }
  }
  
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const tomorrowStr = `${tomorrow.getFullYear()}-${String(tomorrow.getMonth() + 1).padStart(2, '0')}-${String(tomorrow.getDate()).padStart(2, '0')}`;
  return { date: tomorrowStr, time: '10:30' };
};

export const getBusinessHoursForDate = (dateStr, location) => {
  const date = new Date(dateStr + 'T12:00:00');
  const dayOfWeek = date.getDay();
  const hours = businessHours[location] || businessHours.matriz;
  return hours[dayOfWeek];
};

// Día de la semana (0=Dom) y minutos del día en hora de Ecuador, extraídos con
// Intl.DateTimeFormat (robusto; antes new Date(toLocaleString()) fallaba en
// Safari/Firefox y devolvía "cerrado" siempre).
const getEcuadorDayAndMinutes = () => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Guayaquil',
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }).formatToParts(new Date());

  const get = (type) => parts.find((p) => p.type === type)?.value;
  const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  const dayOfWeek = dayMap[get('weekday')];
  let hour = parseInt(get('hour'), 10);
  if (hour === 24) hour = 0; // algunos motores devuelven 24 a medianoche
  const minute = parseInt(get('minute'), 10);
  return { dayOfWeek, currentTime: hour * 60 + minute };
};

// ¿Está abierto AHORA un local concreto? ('matriz' | 'sucursal')
export const isLocationOpen = (location) => {
  const table = businessHours[location];
  if (!table) return false;
  const { dayOfWeek, currentTime } = getEcuadorDayAndMinutes();
  const hours = table[dayOfWeek];
  if (!hours) return false; // ese día el local está cerrado
  return currentTime >= timeToMinutes(hours.open) && currentTime <= timeToMinutes(hours.close);
};

// Estado de apertura por local + agregados. Cada local tiene SU horario:
// los domingos solo abre la Sucursal (09:00-13:00); la Matriz está cerrada.
export const getOpenStatus = () => {
  const matriz = isLocationOpen('matriz');
  const sucursal = isLocationOpen('sucursal');
  return { matriz, sucursal, anyOpen: matriz || sucursal };
};

// Compat: "tienda" = Matriz (la lógica de pedidos/entrega usa Matriz).
export const isStoreCurrentlyOpen = () => isLocationOpen('matriz');
